import Typography from '@mui/material/Typography';
import React, { type FC } from 'react';

interface BasicTitleProps {
  text: string;
}
const BasicTitle: FC<BasicTitleProps> = ({ text }) => {
  return (
    <Typography variant="h5" noWrap component="div" sx={{ fontWeight: 600 }}>
      {text}
    </Typography>
  );
};

export default BasicTitle;
